/**
 * Wraps a translation object with a Proxy that falls back to English
 * for any missing key. If missing in English too, returns the key name.
 * Cost: zero for complete translations (Proxy get-trap is O(1)).
 */
const withFallback = (lang, fallback) =>
  new Proxy(lang, {
    get: (target, key) => {
      if (typeof key === "symbol") return target[key];
      return target[key] || fallback[key] || key;
    }
  });

export default withFallback;
